import React, { Component, Fragment } from "react";
import { styled } from "../stitches.config";
import { observer, inject } from "mobx-react";

//components
import Adslot from "./Adslot";
import PostsList from "./PostsList";
import PostsListBizon from "./PostsListBizon";
import BlockList from "./common/BlockList";
import Footer from "../redesign/components/Footer"

import {
  IS_FEATURE_adunityPartner,
  IS_FEATURE_PAGINATOR_LIST,
  SHOW_STATIC_BLOCKS_CONFIG
} from "./common/constants/constants"
import ScrollToTop from "../helpers/ScrollToTop";

import PaginatorPosts from "../redesign/PaginatorPosts";
import PaginatorPostsMainPage from "src/redesign/PaginatorPostsMainPage";

import PageCover from "../redesign/components/PageCover";
@inject("UIStore")
@observer
export default class Category extends Component {

  render() {
    const { category, store, UIStore } = this.props;
    const categoryBlocks = category.wizard;
    const categoryName = category.name;

    // console.log('[ES] Category', store.status);
    if (store.status !== 'valid') {
      return null;
    }
    // console.log('[ES] Category // render', category, categoryBlocks, categoryName);

    // generuje prefix dla reklam
    const isHomePage = category.OID === 0;
    let adPrefix = "KAT";
    if (category.type === "bliss") {
      adPrefix = "bliss"; //TODO co z tym nazewnictwem?
    } else if (category.type === "trudat") {
      adPrefix = "trudat"; //TODO jw
    } else if (isHomePage) {
      adPrefix = "SG";
    }

    // generuje suffix dla reklam
    const isMaterialPartnera = UIStore.isMaterialPartnera;
    const adSuffix = ((IS_FEATURE_adunityPartner && isMaterialPartnera) ? '_partner' : '');

    // ukrycie billboard_1 jak jest włączony b-one-super
    const hideBillboard1 = (categoryBlocks && categoryBlocks[0] && categoryBlocks[0].type == 'b-one-super');

    return (
      <>
        <Fragment key="home-page-container">
          <ScrollToTop />
          <Adslot name={"belka_sticky" + adSuffix} />
          {hideBillboard1 || <Adslot name={adPrefix + "_Billboard_1" + adSuffix} />}

          <div className="hp" data-lastmod={store.lastModification}>
            {false && category.show_category_title &&
              category.type !== "trudat" && (
                <CategoryType isContact={category.slug === "kontakt"}>
                  {" "}{categoryName}{" "}
                </CategoryType>
              )}
            {category.show_category_title &&
              <PageCover
                title={category.name}
                description={category.description}
                isDescriptionWyswig={false}
                image={category?.picture?.img}
                media={category?.picture?.media}
                extraMargin={categoryBlocks && categoryBlocks.length && categoryBlocks[0].type == 'b-one-super'}
              />}
            <BlockList settings={categoryBlocks} adPrefix={adPrefix} adSuffix={adSuffix} staticShow={SHOW_STATIC_BLOCKS_CONFIG.category_render_blocks['' + category.OID]} />
          </div>

          {isHomePage &&
            <PaginatorPostsMainPage
              label="Popularne"
              id={category.OID}
              dataType="category"
              type="list"
              pageSize={9}
              paginationType={'NO_PAGINATOR'}
              preloadedPosts={category?.last_posts}
            />
          }

          {category.last_posts.length > 0 &&
            (
              <>
                <PaginatorPosts
                  label={categoryName}
                  id={category.OID}
                  dataType="category"
                  type="list"
                  pageSize={10}
                  paginationType={IS_FEATURE_PAGINATOR_LIST ? 'PAGINATOR' : 'INFINITE_LIST'}
                  preloadedPosts={category?.last_posts}
                />
              </>
            )
          }
        </Fragment>
        <Footer />
      </>
    );
  }
};

const CategoryType = styled("div", {
  backgroundColor: "$primary",
  textAlign: "center",
  color: "#fff",
  fontSize: "22px",
  fontWeight: "bold",
  padding: "10px",
  paddingBottom: "19px",
  position: "relative",
  zIndex: -1,
  bottom: "-9px",
  marginBottom: "0",
  variants: {
    "isContact": {
      true: {
        paddingBottom: "12px",
        marginBottom: "29px"
      },
      false: {}
    }
  }
});